import { useUserOrKioskRequest } from "../common/lib/fetch";
import { HttpMethod } from "../common/lib/fetch/useFetch";
import { RequestOptions } from "../common/lib/fetch/useRequest";

const useRequestReprint = (stagedOrderId: string, options: RequestOptions<void>) =>
  useUserOrKioskRequest<void, void>({
    method: HttpMethod.POST,
    path: `/api/pastOrders/${stagedOrderId}/reprint`,
  }, options);

export default useRequestReprint;
